import { matchPath } from 'react-router-dom';
import { FormFieldDataType } from 'models/enum';
import { ContentItem } from 'models/ui';
import { AppConstant, CaseStudyPaths } from 'constants/app.constant';
import flatten from 'lodash/flatten';

export const resetCaseStudyDemoStorage = () => {
  const globalSimsNGState = JSON.parse(localStorage.getItem(AppConstant.PERSIST_KEY));
  if (globalSimsNGState?.instructorState?.caseStudyDemo) {
    globalSimsNGState.instructorState.caseStudyDemo = null;
    localStorage.setItem(AppConstant.PERSIST_KEY, JSON.stringify(globalSimsNGState));
  }
};

export const resetSimulationEhrDemoStorage = () => {
  const globalSimsNGState = JSON.parse(localStorage.getItem(AppConstant.PERSIST_KEY));
  if (globalSimsNGState?.instructorState?.simulationEhrDemo) {
    globalSimsNGState.instructorState.simulationEhrDemo = null;
    localStorage.setItem(AppConstant.PERSIST_KEY, JSON.stringify(globalSimsNGState));
  }
};

export const resetNewAssignmentStorage = (value) => {
  const globalSimsNGState = JSON.parse(localStorage.getItem(AppConstant.PERSIST_KEY));
  if (globalSimsNGState?.instructorState?.newAssignment) {
    globalSimsNGState.instructorState.newAssignment = { ...globalSimsNGState.instructorState.newAssignment, ...value };
    localStorage.setItem(AppConstant.PERSIST_KEY, JSON.stringify(globalSimsNGState));
  }
};

export const isCaseStudyStep = (pathname): boolean => {
  if (!pathname) return false;
  return !!matchPath(pathname, CaseStudyPaths)?.path;
};

export const getStandaloneProductItems = (products): ContentItem[] => {
  return products.map((product, index) => {
    const [key, value] = flatten(Object.entries(product));
    return {
      dataType: FormFieldDataType.CHOICE,
      displayOrder: index,
      id: String(key).toLocaleLowerCase(),
      name: String(value),
      label: String(value),
      onChange: null,
      isActive: true,
      selected: false,
      value: String(key)
    };
  });
};
